import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AnswersAddEditPage from 'components/pages/AnswersAddEdit';
import pageTitles from 'utils/pageTitles';
import getRouteState from 'utils/getRouteState';
import { historyShape } from 'utils/shapes/router.shapes';

import { setTitle, setActiveMenuItem } from 'containers/store';

import {
  onSubmit, onCancel, loadPageData,
} from './store';

class AnswersAddEdit extends React.Component {
  static propTypes = {
    history: historyShape.isRequired,
    intl: intlShape.isRequired,
    isLoadedPage: PropTypes.bool.isRequired,
    loadPageData: PropTypes.func.isRequired,
    setActiveMenuItem: PropTypes.func.isRequired,
    setTitle: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.setTitle(this.props.intl.formatMessage(pageTitles.answers));
    this.props.setActiveMenuItem('answers');
    const routeState = getRouteState(this.props.history);
    this.props.loadPageData(routeState);
  }

  render() {
    return this.props.isLoadedPage ? (
      <AnswersAddEditPage
        {...this.props}
      />
    ) : null;
  }
}

const mapDispatchToProps = {
  setTitle,
  onSubmit,
  onCancel,
  loadPageData,
  setActiveMenuItem,
};

const mapStateToProps = (state) => ({
  ...state.AnswersAddEdit,
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(AnswersAddEdit)));
